import "../styles/component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

function UroSurgery() {
  return (
        <>
            <section className="general-surgery hide-on-mobile">
                <img
                    src={require("../assets/img/services/big-6.png")}
                    alt="General Surgery"
                    className="top-band-img"
                />
            </section>
            <section className="general-surgery-content">
                <div className="1stblock">
                    <span className="title">What is Uro-Surgery?</span>
                    <p>
                        Uro-surgery focuses on the surgical treatment of urinary tract and related conditions affecting both men and women.
                    </p>
                </div>
                <div className="general-surgery-row">
                    <div className="general-surgery-col general-surgery-col-1">
                        <span className="subtitle">Services Include:</span>
                        <ul className="general-surgery-list">
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Surgical management of urinary tract conditions
                            </li>
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Planned urological procedures as advised by specialists
                            </li>
                            {/* <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Post-trauma and post-surgical reconstruction
                            </li> */}
                        </ul>
                    </div>
                    <div className="general-surgery-col general-surgery-col-2">
                        <span className="subtitle">Why This Service Matters</span>
                        <p>Proper evaluation and surgical care help manage urological conditions effectively and safely.</p>
                    </div>
                </div>
            </section>
           
        </>
    )
}

export default UroSurgery;
